import React, { Component } from "react";
import { FormGroup, FormControl, FormLabel, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import * as userActions from "actions/userActions";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Logo from "components/Logo";
import { isHaddockEnvironment } from "utils/documentUtils";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { PiTimer } from "react-icons/pi";
import { resolvePostLoginRedirect } from "components/Onboarding";

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			submitted: false,
			username: "",
			password: "",
			user: {},
			errors: {},
			showHaddockError: false,
			showPassword: false,
		};
	}

	togglePasswordVisibility = () => {
		this.setState((prevState) => ({
			showPassword: !prevState.showPassword,
		}));
	};

	enableSubmitButton() {
		return this.state.username.length > 0 && this.state.password.length > 0;
	}

	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		const { username, password } = this.state;

		await this.props.login(username, password);

		if (this.props.loggedIn) {
			// Admins sin onboarding completado van directos a la página de
			// onboarding; el resto, al inicio.
			const target = await resolvePostLoginRedirect("/");
			this.props.history.push(target);
		} else {
			this.setState({
				submitted: true,
				isLoading: false,
				showHaddockError: isHaddockEnvironment(),
				errors: errorFormating(this.props),
			});
		}
	};

	render() {
		const { t, error_message } = this.props;

		return (
			<div className="Auth Auth-login">
				<div className="login-shell">
					<div className="login-container login-container-sign-in">
						<Logo className="logo" type="logo" />

						<div className="login-title">{t("login.title")}</div>
						<div className="login-subtitle">{t("login.subtitle")}</div>

						<form onSubmit={this.handleSubmit} className="login-form">
							<FormGroup
								className="form-group login-form-group"
								controlId="username"
							>
								<FormLabel>{t("login.email")}</FormLabel>
								<FormControl
									autoFocus
									type="email"
									value={this.state.username}
									onChange={this.handleChange}
									isInvalid={this.checkValidField("username")}
									placeholder={t("login.emailPlaceholder")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.username}
								</FormControl.Feedback>
							</FormGroup>
							<FormGroup
								className="form-group login-form-group"
								controlId="password"
							>
								<div className="login-password-heading">
									<FormLabel>{t("login.password")}</FormLabel>
									<Link
										className="login-forgot-password"
										to="/remember-password"
									>
										{t("login.forgotPassword")}
									</Link>
								</div>
								<div className="password-input-wrapper">
									<FormControl
										value={this.state.password}
										onChange={this.handleChange}
										type={this.state.showPassword ? "text" : "password"}
										isInvalid={this.checkValidField("password")}
										placeholder="••••••••"
										autoComplete="current-password"
									/>
									<button
										type="button"
										className="password-toggle-btn"
										onClick={this.togglePasswordVisibility}
										aria-label={
											this.state.showPassword
												? t("login.hidePassword")
												: t("login.showPassword")
										}
									>
										{this.state.showPassword ? (
											<FiEyeOff size={18} />
										) : (
											<FiEye size={18} />
										)}
									</button>
								</div>
								<FormControl.Feedback type="invalid">
									{this.state.errors.password}
								</FormControl.Feedback>
							</FormGroup>

							{error_message && (
								<div className="alert alert-danger">{error_message}</div>
							)}

							<SubmitButton
								block
								disabled={!this.enableSubmitButton()}
								type="submit"
								isLoading={this.state.isLoading}
								text={t("login.submit")}
								loadingText={t("login.submitting")}
							/>
						</form>

						<div className="login-divider" aria-hidden="true">
							<span>{t("login.or")}</span>
						</div>

						<Link
							className="login-terminal-link btn btn-outline-primary"
							to="/clockin"
						>
							<PiTimer aria-hidden="true" />
							{t("login.openTerminal")}
						</Link>
					</div>

					{!isHaddockEnvironment() && (
						<div className="login-links">
							<div>
								{t("login.noAccount")}{" "}
								<a href="https://plain.ninja/demo/">{t("login.scheduleDemo")}</a>
							</div>
						</div>
					)}
				</div>

				<Modal
					show={this.state.showHaddockError}
					onHide={() => this.setState({ showHaddockError: false })}
					dialogClassName="haddock-login-modal"
					centered
				>
					<Modal.Body style={{ padding: "24px" }}>
						<p style={{ fontWeight: "600", fontSize: "16px", color: "#333" }}>
							{t("login.haddockModal.text1")}
						</p>
						<p style={{ color: "#444" }}>
							<Trans i18nKey="login.haddockModal.text2">
								Por favor, verifica que estás utilizando el usuario y la contraseña
								correctos. Si tienes dudas, usa la opción de{" "}
								<Link to="/remember-password">recuperación de contraseña</Link>.
							</Trans>
						</p>

						<p style={{ fontStyle: "italic", color: "#6c757d", marginTop: "24px", marginBottom: 0 }}>
							{t("login.haddockModal.text3")}
						</p>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.authReducer;
};

export default connect(mapStateToProps, userActions)(withTranslation()(Login));
